// Product Template JavaScript
(function() {
  'use strict';
  
  let moneyFormat = window.productMoneyFormat || window.moneyFormat || '';
  
  // Product Info Popup Functions
  function openProductInfo() {
    const popup = document.getElementById('productInfoPopup');
    if (popup) {
      popup.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
  }
  
  function closeProductInfo() {
    const popup = document.getElementById('productInfoPopup');
    if (popup) {
      popup.classList.add('hidden');
      document.body.style.overflow = '';
    }
  }
  
  // Format price using money format template
  function formatPrice(amount) {
    const formatted = amount.toFixed(2).replace(/\.00$/, '');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted);
  }
  
  // Update price elements
  function updatePrices(variant) {
    const price = variant.price / 100;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
    
    // Update regular prices
    document.querySelectorAll('.js-product-price').forEach(el => {
      el.textContent = formatPrice(price);
      el.setAttribute('content', price.toString());
    });
    
    // Update compare prices
    document.querySelectorAll('.js-compare-price').forEach(el => {
      if (comparePrice && comparePrice > price) {
        el.innerHTML = `<s class="text-gray-500">${formatPrice(comparePrice)}</s>`;
      } else {
        el.innerHTML = '';
      }
    });
  }
  
  // Update button state
  function updateButtonState(enabled) {
    const addToCartBtn = document.getElementById('AddToCart');
    const addToCartText = document.getElementById('AddToCartText');
    const paymentButtons = document.getElementById('PaymentButtons');
    
    if (addToCartBtn) {
      addToCartBtn.disabled = !enabled;
      addToCartBtn.classList.toggle('is-active', enabled);
      if (addToCartText && enabled) {
        addToCartText.textContent = 'Add to basket';
      }
    }
    
    if (paymentButtons) {
      paymentButtons.style.display = enabled ? 'block' : 'none';
    }
  }
  
  // Validate and update variant selection
  function selectValidate() {
    const productSelect = document.getElementById('ProductSelect');
    if (!productSelect) return;
    
    // Single variant: enable button
    if (productSelect.classList.contains('hidden')) {
      updateButtonState(true);
      return;
    }
    
    // Multiple variants: check selection
    const selectedOption = productSelect.options[productSelect.selectedIndex];
    if (!selectedOption?.value || selectedOption.disabled) {
      updateButtonState(false);
      return;
    }
    
    // Fetch variant data
    const variantId = selectedOption.value;
    const variantUrl = `${window.Shopify?.routes?.root || ''}variants/${variantId}.js`;
    
    fetch(variantUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(variant => {
        updatePrices(variant);
        updateButtonState(true);
      })
      .catch(error => {
        console.error('Error fetching variant:', error);
        updateButtonState(false);
      });
  }
  
  // Initialize when DOM is ready
  function init() {
    const productSelect = document.getElementById('ProductSelect');
    if (productSelect) {
      selectValidate();
      productSelect.addEventListener('change', selectValidate);
    }
    
    // Close popup when clicking outside
    const popup = document.getElementById('productInfoPopup');
    if (popup) {
      popup.addEventListener('click', function(e) {
        if (e.target === this) {
          closeProductInfo();
        }
      });
    }
  }
  
  // Expose functions globally
  window.openProductInfo = openProductInfo;
  window.closeProductInfo = closeProductInfo;
  window.selectValidate = selectValidate;
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); 